import { Pipe, PipeTransform } from '@angular/core';
import {Whiteboard} from '@app/state/whiteboard.state';

@Pipe({
  name: 'isShared'
})
export class IsSharedPipe implements PipeTransform {

  public transform(whiteboard: Whiteboard): boolean {
    return whiteboard?.sharedUsers?.size != null;
  }
}
